// Ajustes del espacio de trabajo: cuenta y 2FA, miembros, estado de las webs, copias de seguridad y actividad.
import { t } from '../../i18n/index.ts';
import { navigate } from '../../router.ts';
import { useApp } from '../../store.ts';
import { TopBar } from '../../ui/TopBar.tsx';
import { Account } from './Account.tsx';
import { Members } from './Members.tsx';
import { StatusPage } from './Status.tsx';
import { Backups } from './Backups.tsx';
import { Activity } from './Activity.tsx';

export function WorkspaceShell({ section }: { section: string }) {
  const me = useApp((s) => s.me);
  const items = [
    { id: 'account', label: 'ws.account' },
    { id: 'members', label: 'ws.members' },
    { id: 'status', label: 'ws.status' },
    { id: 'backups', label: 'ws.backups' },
    ...(me?.role === 'owner' ? [{ id: 'activity', label: 'ws.activity' }] : []),
  ];
  const Section = { account: Account, members: Members, status: StatusPage, backups: Backups, activity: Activity }[section] ?? Account;
  return (
    <div className="settings">
      <TopBar mode={t('mode.workspace')} menu={[{ label: t('common.goToDashboard'), onSelect: () => navigate('/') }]} center={<span className="ellipsis">{t('ws.name')}</span>} />
      <div className="settings-body">
        <nav className="settings-nav">
          <div className="group">{t('ws.settings')}</div>
          {items.map((it) => (
            <button key={it.id} type="button" className={`side-item${section === it.id ? ' active' : ''}`} onClick={() => navigate(`/settings/${it.id}`)}>
              <span>{t(it.label)}</span>
            </button>
          ))}
        </nav>
        <main className="settings-main">
          <div className="settings-page">
            <Section key={section} />
          </div>
        </main>
      </div>
    </div>
  );
}
